/* Presteem — bouton « Buy now » : ajout au panier via l'API Ajax de Shopify (déclenche l'événement
   standard product_added_to_cart, donc AddToCart pour le pixel TikTok), puis redirection vers le checkout.
   En cas d'échec, on suit le lien d'origine (permalien panier). Aucun changement visuel,
   hormis un léger état « en cours » sur le bouton cliqué. */
(function () {
  var busy = false, current = null;

  function reset() {
    busy = false;
    if (current) { current.removeAttribute('aria-busy'); current.style.opacity = ''; current.style.cursor = ''; current = null; }
  }
  // Retour arrière depuis le checkout (page restaurée depuis le cache) : le bouton doit refonctionner.
  window.addEventListener('pageshow', reset);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.add-button');
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/cart\/(\d+):(\d+)/);
    if (!m || !window.fetch) return;
    e.preventDefault();
    if (busy) return;
    busy = true; current = a;
    a.setAttribute('aria-busy', 'true'); a.style.opacity = '.75'; a.style.cursor = 'progress';
    var fallback = a.href;
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    var go = function (url) { window.location.href = url; };
    var guard = setTimeout(function () { go(fallback); }, 6000);   // never leave the shopper waiting
    fetch('/cart/clear.js', { method: 'POST', headers: json })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(m[1]), quantity: Number(m[2]) }] }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
      .then(function () { clearTimeout(guard); setTimeout(function () { go('/checkout'); }, 300); })   // laisse partir l'événement AddToCart (validé avec TikTok)
      .catch(function () { clearTimeout(guard); go(fallback); });
  }, true);
})();
